<app-loading *ngIf="loading"></app-loading>

<!-- Erreur -->
<div *ngIf="error && !loading" class="loi-detail-error container">
    <i class="icofont-warning-alt"></i>
    <p>{{ error | translate }}</p>
    <a [routerLink]="['/loi']" class="careox-btn">{{ 'loi_retour' | translate }}</a>
</div>

<ng-container *ngIf="article && !loading">

    <!-- ══ En-tête ════════════════════════════════════════════════════ -->
    <section class="loi-detail-hero">
        <div class="loi-detail-hero__bg"></div>
        <div class="container">
            <div class="loi-detail-hero__content">
                <span class="loi-badge" [class]="getCategoryColor()">
                    {{ getCategoryLabel() }}
                </span>
                <h1 class="loi-detail-hero__title">{{ tfInterface(article.title) }}</h1>
                <div class="loi-detail-hero__meta">
                    <span *ngIf="article.article_number">
                        <i class="icofont-document-folder"></i> {{ article.article_number }}
                    </span>
                    <span *ngIf="article.law_reference">
                        <i class="icofont-link"></i> {{ article.law_reference }}
                    </span>
                    <span>
                        <i class="icofont-calendar"></i> {{ formatDate(article.published_at) }}
                    </span>
                </div>
            </div>
        </div>
    </section>

    <!-- ══ Corps ══════════════════════════════════════════════════════ -->
    <section class="loi-detail-body">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">

                    <!-- Sélecteur de langue du contenu -->
                    <div class="loi-detail-langs">
                        <span class="loi-detail-langs__label">
                            <i class="icofont-globe"></i> {{ 'loi_langue_contenu' | translate }} :
                        </span>
                        <button class="loi-lang-btn"
                                [class.active]="activeLang === 'fr'"
                                (click)="activeLang = 'fr'"
                                *ngIf="hasLang(article.title, 'fr')">
                            🇫🇷 Français
                        </button>
                        <button class="loi-lang-btn"
                                [class.active]="activeLang === 'en'"
                                (click)="activeLang = 'en'"
                                *ngIf="hasLang(article.title, 'en')">
                            🇬🇧 English
                        </button>
                        <button class="loi-lang-btn"
                                [class.active]="activeLang === 'ar'"
                                (click)="activeLang = 'ar'"
                                *ngIf="hasLang(article.title, 'ar')">
                            🇲🇷 العربية
                        </button>
                    </div>

                    <!-- Chapitre / Section -->
                    <div class="loi-detail-meta-box" *ngIf="tf(article.chapter) || tf(article.section)">
                        <div class="loi-detail-meta-box__item" *ngIf="tf(article.chapter)">
                            <span class="loi-detail-meta-box__label">{{ 'loi_chapitre' | translate }}</span>
                            <span class="loi-detail-meta-box__value">{{ tf(article.chapter) }}</span>
                        </div>
                        <div class="loi-detail-meta-box__item" *ngIf="tf(article.section)">
                            <span class="loi-detail-meta-box__label">{{ 'loi_section' | translate }}</span>
                            <span class="loi-detail-meta-box__value">{{ tf(article.section) }}</span>
                        </div>
                    </div>

                    <!-- Contenu principal -->
                    <div class="loi-detail-content"
                         [class.rtl]="activeLang === 'ar'"
                         [innerHTML]="tf(article.content)">
                    </div>

                    <!-- Tags -->
                    <div class="loi-detail-tags" *ngIf="article.tags?.length">
                        <span class="loi-detail-tags__label">
                            <i class="icofont-tag"></i> {{ 'loi_tags' | translate }}
                        </span>
                        <span class="loi-tag" *ngFor="let tag of article.tags">{{ tag }}</span>
                    </div>

                    <!-- Retour -->
                    <div class="loi-detail-back">
                        <a [routerLink]="['/loi']" class="loi-back-btn">
                            <i class="icofont-arrow-left"></i>
                            {{ 'loi_retour' | translate }}
                        </a>
                        <a [routerLink]="['/loi']"
                           [queryParams]="{category: article.category}"
                           class="loi-back-btn loi-back-btn--cat">
                            <span class="loi-badge" [class]="getCategoryColor()">{{ getCategoryLabel() }}</span>
                            {{ 'loi_voir_categorie' | translate }}
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </section>

</ng-container>
